export function handoffNotice(handoff) {
  if (handoff?.status === 'success') {
    return {
      message: `${handoff.package_name} was added for ${handoff.username}.`,
      duration: undefined,
      type: undefined,
      openBasket: true,
    };
  }

  if (handoff?.reason === 'rank_limit') {
    return {
      message: 'You cannot put more than 1 rank in your basket at a time.',
      duration: 6000,
      type: 'error',
      openBasket: true,
    };
  }

  if (handoff?.reason === 'rank_ineligible') {
    return { message: 'This rank package is not available for your current Minecraft rank.', duration: 6000, type: 'error', openBasket: false };
  }

  if (handoff?.reason === 'rank_unavailable') {
    return { message: 'Rank eligibility is temporarily unavailable. Please try again later.', duration: 6000, type: 'error', openBasket: false };
  }

  if (handoff?.reason === 'ip_unavailable') {
    return {
      message: 'Could not determine your public IPv4 address for checkout. Please try again.',
      duration: 6000,
      type: 'error',
      openBasket: false,
    };
  }

  return {
    message: 'That in-game store link expired or could not be used.',
    duration: 6000,
    type: 'error',
    openBasket: false,
  };
}
